import React from 'react';
import cn from 'classnames';
import { WideArrowBackward } from "../../icons/WideArrowBackward";
import { IconButton } from "../IconButton";
import { Spinner } from "../Spinner";
import { Typography } from "../Typography";
import styles from "./PageHeader.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Renders the top content of a page. */
export function PageHeader(props) {
  const {
    title,
    subheader,
    actions,
    loading,
    onClickBack,
    className
  } = props;
  const shouldShowBackButton = Boolean(onClickBack);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.container, className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn(styles.leadingArea, {
        [styles.backButtonShown]: shouldShowBackButton
      }),
      children: [shouldShowBackButton && /*#__PURE__*/_jsx(IconButton, {
        className: styles.backButton,
        testId: props.testId && "".concat(props.testId, "-back-button"),
        onClick: onClickBack,
        children: /*#__PURE__*/_jsx(WideArrowBackward, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsx(Typography, {
          as: "span",
          variant: "h4",
          weight: "normal",
          testId: props.testId && "".concat(props.testId, "-page-header"),
          children: title
        }), loading && /*#__PURE__*/_jsx(Spinner, {
          size: 40,
          testId: "page-loading"
        })]
      }), subheader && /*#__PURE__*/_jsx(Typography, {
        className: styles.subheader,
        testId: props.testId && "".concat(props.testId, "-page-subheader"),
        children: subheader
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.actions,
      "data-testid": props.testId && "".concat(props.testId, "-actions"),
      children: actions
    })]
  });
}